import styled from 'styled-components';
import { respondTo } from 'assets/styled/breakpoints';
import { Form } from 'formik';

export const StyledForm = styled(Form)`
  max-width: 580rem;
  width: 100%;

  ${respondTo.bigPhone`
    width: 100%;
  `}
`;

export const DoubleFieldWrapper = styled.div`
  display: flex;
  gap: 20rem;
  margin-bottom: 25rem;
`;

export const FieldWrapper = styled.div`
  width: 100%;
  margin-bottom: 25rem;

  ${respondTo.bigPhone`
    width: 100%;
    max-width: 100%;
  `}
`;

export const PasswordInputWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 20rem;

  ${respondTo.bigPhone`
    width: 100%;
    max-width: 100%;
  `}
`;

export const ButtonContainer = styled.div`
  width: 100%;
`;

export const EyeWrapper = styled.div`
  user-select: none;
  position: absolute;
  top: 50%;
  right: 15rem;
  transform: translateY(-50%);
`;
